module.exports = __webpack_public_path__ + "static/sample-insurance-8582afeb5b935801aae0a3bf35bed0fe.svg";